export const MTCN_SEARCH_STARTED = 'MTCN_SEARCH_STARTED';
export const MTCN_SEARCH_SUCCESS = 'MTCN_SEARCH_SUCCESS';
export const MTCN_SEARCH_ERROR = 'MTCN_SEARCH_ERROR';